import { useTranslation } from 'react-i18next';
import classes from './FieldEditor.module.css';
import { type FieldKind, PALETTE } from './model';

export function FieldPalette({ onAdd }: { onAdd: (kind: FieldKind) => void }) {
  const { t } = useTranslation();
  return (
    <aside className={`${classes.panel} ${classes.palette}`} aria-label={t('fields.paletteLabel')}>
      {PALETTE.map(({ group, kinds }) => (
        <div key={group}>
          <p className={classes.paletteHead}>{t(`fields.${group}`)}</p>
          {kinds.map((kind) => (
            <button
              key={kind}
              type="button"
              className={classes.paletteButton}
              onClick={() => onAdd(kind)}
              aria-label={t('fields.addKind', { kind: t(`fields.kind.${kind}`) })}
            >
              <span aria-hidden="true">+</span>
              {t(`fields.kind.${kind}`)}
            </button>
          ))}
        </div>
      ))}
    </aside>
  );
}
